module.exports = __webpack_public_path__ + "img/01-BABO-C-off.d97f9183.png";